"use client";

import { createContext, type ReactNode, useContext } from "react";
import type { SeededJsonTranslations } from "@/lib/i18n/json-translations-server";

const JsonTranslationsContext = createContext<SeededJsonTranslations>({});

export function JsonTranslationsProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: SeededJsonTranslations;
}) {
  return (
    <JsonTranslationsContext.Provider value={value}>
      {children}
    </JsonTranslationsContext.Provider>
  );
}

export function useSeededJsonTranslations() {
  return useContext(JsonTranslationsContext);
}
